import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

   export const getData = createAsyncThunk('emailSettings/getData', async (params) => {
       
      const response = await axios.post(' https://api.zasway.com:8443/EmailSettings/GetTableSummary', params, {mode:'cors'})
       
         return {
            params,
            data: response.data
         }
   })

   export const getUsers = createAsyncThunk('emailSettings/getUsers', async (params) => {
      
      const response = await axios.post(' https://api.zasway.com:8443/EmailSettings/GetUsers', params, {mode:'cors'})
         
      return {
            params,
            data: response.data
         }
   })

   export const addEmailSettings = createAsyncThunk('emailSettings/addEmailSettings', async (Email) => {
      const response = await axios.post(' https://api.zasway.com:8443/EmailSettings/Create', Email, {mode:'cors'})
         return response
   })

   export const editEmailSettings  = createAsyncThunk('emailSettings/editEmailSettings', async (Edit) => {
      
      const response = await axios.post(' https://api.zasway.com:8443/EmailSettings/Update', Edit, {mode:'cors'})
         
      return response
   })

export const emailSettingsSlice = createSlice({
   name: 'emailSettings',
   initialState: {
      EmailSettingsEditData: [],
      EmailUserData: [],
      EmailEditData: []
   },
     reducers: {},
      extraReducers: builder => {
         builder

         .addCase(getData.fulfilled, (state, action) => {
            state.EmailEditData = action.payload.data
         })
         
         .addCase(getUsers.fulfilled, (state, action) => {
            
            state.EmailUserData = action.payload.data
         })

         .addCase(editEmailSettings.fulfilled, (state, action) => {
            
            state.EmailSettingsEditData = action.payload.data
         })
      }
})
   
 export default emailSettingsSlice.reducer